import { render, staticRenderFns } from "./kpzq.vue?vue&type=template&id=6cb7e4fa&scoped=true"
import script from "./kpzq.vue?vue&type=script&lang=js"
export * from "./kpzq.vue?vue&type=script&lang=js"
import style0 from "./kpzq.vue?vue&type=style&index=0&id=6cb7e4fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7e4fa",
  null
  
)

export default component.exports